<template>
  <div class="project-autopilots-add">
    <TText
      text="Add autopilots"
      font_weight="500"
      size="24"
    />
    <div
      class="project-autopilots-type"
      v-for="autopilot in getAutopilots"
      :key="autopilot.type"
    >
      <TText
        :text="`Type: ${autopilot.type}`"
        font_weight="400"
      />

      <div class="project-autopilots-type-functions">
        <div
          class="project-autopilots-add-card"
          v-for="ap_function in autopilot.functions"
          :key="ap_function.name"
          :style="`${is_active(ap_function) ? 'opacity: .5;' : ''}`"
        >
          <div class="project-autopilots-add-card-head">
            <!-- Name -->
            <TText
              :text="ap_function.name"
              color="black"
              font_weight="500"
              size="16"
            />

            <!-- Add Button -->
            <v-btn
              v-if="!is_active(ap_function)"
              icon
              color="black"
              @click="createUObject({
                  url: [
                    {projects: project_id},
                    {autopilotprojects: ''},
                    {showWithEntitiesNormalized:''}
                  ],
                  u_object: {
                    'add#autopilots': [ap_function.levels[0].id]
                  }
                })"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <!-- Is Active Checkmark -->
            <v-icon
              v-else
              class="project-autopilots-add-card-check"
              color="black"
            >
              mdi-check
            </v-icon>
          </div>

          <!-- Radio Buttons -->
          <div>
            <RadioKnobRow
              :knobs="ap_function.levels"
              :selected_id="isFunctionInProject({name: ap_function.name, project_id: project_id})"
              :cell_count="4"
              :is_disabled="true"
              :height="32"
              :width="32"
              @knobClicked="knobClicked(ap_function.levels, $event)"
            />
          </div>

          <!-- Description -->
          <TText
            class="project-autopilots-add-card-description"
            :text="ap_function.description"
            color="black"
            small
            max_lines="4"
          />

          <div class="project-autopilots-add-line"/>

          <div class="project-autopilots-add-card-buttons">
            <ButtonOutlined
              text="More..."
              text_size="10"
              color="black"
              width="64"
              height="24"
              @buttonClicked="$router.push({
                name: 'ProjectAutoPilotsAddDetails',
                params: {autopilot_add_id: ap_function.levels[0].id}
              })"
            />
          </div>

          <!-- <div>level count: {{ap_function.levels.length}}</div>
          <div>
            level in project?{{isFunctionInProject({name: ap_function.name, project_id: project_id})}}
          </div> -->
        </div>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import TText from '@/components/Taktify/TText.component.vue';
  import RadioKnobRow from '@/modules/WorkPackageWIP/RadioKnobRow.module.vue';
  import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';

  export default {
    components: {
      TText,
      RadioKnobRow,
      ButtonOutlined,
    },

    props: [],

    data: () => ({

    }),

    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
        'getUObjectsFiltered',
      ]),

      ...mapGetters('AutopilotRework', [
        'getAutopilots',
        'isFunctionInProject'
      ]),

      project_id() {
        return this.$route.params.project_id;
      },
    },

    methods: {
      ...mapActions('Ultra', [
        'requestUObject',
        'createUObject',
        'updateUObject',
        'deleteUObject'
      ]),

      is_active(ap_function) {
        return this.isFunctionInProject({name: ap_function.name, project_id: this.project_id}) != -1;
      },
    }
  }
</script>

<style>
  .project-autopilots-add {
    margin: 16px;
  }
  .project-autopilots-type-functions {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 16px;
    margin: 16px 0;
  }
  .project-autopilots-add-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .project-autopilots-add-card-check {
    padding: 6px;
  }
  .project-autopilots-add-card-description {
    margin: 0 8px;
    height: 60px;
  }
  .project-autopilots-add-line {
    width: 100%;
    border-top: 1px black solid;
    opacity: .5;
    margin: 16px 0;
  }
  .project-autopilots-add-card-buttons {
    display: flex;
    justify-content: flex-end;
  }
  .project-autopilots-add-card {
    min-width: 300px;
    max-width: 300px;
    background-color: #AAA;
    color: black;
    padding: 8px;
    border-radius: 8px;
  }
</style>
